import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialRejectionOutwardPopup } from './MaterialRejectionOutwardTable';
import { decryptAES, encryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';

export default class MaterialRejectionOutward extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            route: null,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isSelectItemPopUp: false,
            materialRejectionList: [],
            materialList: [],
            rejectedItemList: [],
            selectRejItemColDefs: [
                {
                    field: "material",
                    headerName: "Material",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "rejectionNo",
                    headerName: "Rejection No",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "pendingQty",
                    headerName: "Pending Qty",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            isShown: false,
            partyAccountList: [],
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialObject: {
                idMaterialRejection: 0,
                idMaterialRejectionRef: 0,
                rejectionRefNo: '',
                idMaterial: 0,
                materialName: '',
                isApprove: false,
                idMaterialIssueJobWork: 0,
                idMaterialTesting: 0,
                updateStatus: 0,
                rejectionNo: '',
                rejectionDate: '',
                idRejection: 1,
                rejList: [
                    { value: 1, label: 'MATERIAL TESTING' },
                    { value: 2, label: 'REWORK PRODUCT' },
                ],
                idEmployee: 0,
                EmployeeList: [],
                idVendor: 0,
                workOrderList: [],
                testingDate: '',
                idRejType: 1,
                rejTypeList: [
                    { value: 1, label: 'INTRASTATE' },
                    { value: 2, label: 'INTERSTATE' },
                ],

                totalQty: '',
                totalAmt: '',
                taxAmt: '',
                taxableAmt: '',
                totalwithTax: '',
                finalAmt: '',
                adjustableAmt: '',
                prefix: '',
            },
            itemObject: {
                drawingNo: '',
                idType: 1,
                TypeList: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                ],
                idItem: 0,
                ItemList: [],
                quantity: '',
                weight: '',
                rate: '',
                amount: '',
                idTaxGroup: 0,
                taxList: [],
                sgst: '',
                cgst: '',
                igst: '',
                sgstAmt: '',
                cgstAmt: '',
                igstAmt: '',
                netTotal: '',
                remarks: '',
                rejQuantity: 0,
                idMaterialRejection: 0,
                idMaterialRejectionItems: 0,
                materialType: '',
                pendingQty: 0,
                rejectionNo: '',
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idMaterial: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "material"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }


    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_GetAllUsers();
                this.getMaterialListForOutward();
            });
        }
    }

    getMaterialListForOutward = () => {
        this.transactionStockServices.usp_Master_MaterialSelect_ForOutward(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let materialList = data.map((x) => ({
                    value: x.value,
                    label: x.label,
                }));
                this.setState({ materialList: materialList });
            }
        });
    }

    getRejectedItemsByMaterial = () => {
        let request = [this.state.idCompany, this.state.materialObject.idMaterial];
        this.transactionStockServices.usp_Transaction_MaterialRejectionItemSelect_ForOutward_ByMaterial(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // Hide items already added to the grid (unique by idMaterialRejectionItems) for better UX
                let addedIds = this.state.itemRowData.map(x => x.idMaterialRejectionItems);
                data = data.filter(x => !addedIds.includes(x.idMaterialRejectionItems));
                this.setState({ rejectedItemList: data });
            }
        });
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Rejection Outward",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialRejectionOutward", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Rejection Outward",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Material Rejection Outward");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    usp_Master_PartyAccountSelect = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectSupplier(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    this.getTaxStructure()
                    this.setState({ partyAccountList: dynamicData }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getTaxStructure()
                }
            }
        });
    }

    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    value: x.idTaxStructure,
                    label: x.taxStructureName,
                }));
                let itemObject = this.state.itemObject;
                itemObject.taxList = res;
                this.setState({
                    itemObject: itemObject
                }, () => {
                    // this.usp_Master_ItemSelectForAuto()
                })
            } else {
                // this.usp_Master_ItemSelectForAuto()
            }
        });
    }

    // usp_Master_ItemSelectForAuto = () => {
    //     this.transactionStockServices.usp_Master_ItemSelectForAuto(this.state.idCompany).then((response) => {
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let res = response.responseItem.responseContent;
    //             res = res.map((x) => ({
    //                 id: x.idTaxStructure,
    //                 name: x.taxStructureName,
    //             }));
    //             let itemObject = this.state.itemObject;
    //             itemObject.ItemList = res;
    //             this.setState({
    //                 itemObject: itemObject
    //             }, () => {
    //             })
    //         } else {
    //         }
    //     });
    // }

    getColumnWidth = (key) => {
        const colwidth = {
            "srNo": window.innerWidth * 0.04,
            "rejectionNo": window.innerWidth * 0.05,
            "rejectionDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.17,
            "rejectionFrom": window.innerWidth * 0.11,
            "totalQty": window.innerWidth * 0.06,
            "totalAmt": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
            "testingNo": window.innerWidth * 0.06,
            "closeStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemCategory": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.15,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "amount": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.04,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.04,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.04,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    handleCellClick = (event) => {
        let data = this.state.materialObject;
        data.idMaterialRejection = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ materialObject: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Material Rejection Outward");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        // if (!this.state.permissions.isAddEdit) {
        //     this.SwalServices.Error(permission.add);
        //     return;
        // }
        this.transactionStockServices.usp_Transaction_MaterialRejectionOutwardCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let materialObject = this.state.materialObject
                materialObject.rejectionNo = formatted
                materialObject.rejectionDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ materialObject: materialObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
        this.getMaterialRejectionOutwardSelectbyId(event.data[this.state.colName]);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.materialObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.materialObject;
        details[name] = value;
        this.setState({ materialObject: details }, () => {
            this.finalCalculation()
        });
    }

    handleApproveChange = (event) => {
        let details = this.state.materialObject;
        details.isApprove = event.target.checked;
        this.setState({ materialObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            if (name === "quantity" || name === "rate") {
                this.calculatePricing()
            }
        });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.materialObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'materialObject') {
            details[name] = value;
            if (name === "idMaterial") {
                details.materialName = event.label;
            }
            this.setState({ materialObject: details });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details1 }, () => {
                if (name === "idType") {
                    this.getMaster_ItemSelectbyItemType(event.label);
                }
                if (name === "idTaxGroup") {
                    this.getTaxStructureSelectbyID();
                }
            });
        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let details = this.state.materialObject;
        details.idMaterialRejection = 0;
        details.idMaterialRejectionRef = 0;
        details.rejectionRefNo = '';
        details.idMaterial = 0;
        details.materialName = '';
        details.isApprove = false;
        details.remarks = '';
        details.idMaterialIssueJobWork = 0;
        details.idMaterialTesting = 0;
        details.rejectionDate = moment(new Date()).format('YYYY-MM-DD');
        details.idRejection = 1;
        details.idEmployee = 0;
        details.idVendor = 0;
        details.testingDate = '';
        details.totalQty = '';
        details.totalAmt = '';
        details.taxAmt = '';
        details.taxableAmt = '';
        details.totalwithTax = '';
        details.finalAmt = '';
        details.adjustableAmt = '';
        details.prefix = '';
        this.setState({
            validState: validState,
            materialObject: details,
            itemRowData: [],
        }, () => {
            this.resetitemObject();
        });
    }

    handleOnClick = (event, name) => {
        if (name === "itemList") {
            if (!(this.state.materialObject.idMaterial > 0)) {
                this.SwalServices.Error("Please select material first.");
                return;
            }
            this.getRejectedItemsByMaterial();
            this.setOpenModel2();
        }
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        data.drawingNo = event.data.drawingNo || "";
        data.materialType = event.data.itemType || "";
        data.idType = this.state.itemObject.TypeList?.find(t => t.label === event.data.itemType)?.value || data.idType;
        data.idMaterialRejection = event.data.idMaterialRejection;
        data.idMaterialRejectionItems = event.data.idMaterialRejectionItems;
        data.pendingQty = event.data.pendingQty;
        data.quantity = event.data.pendingQty;
        data.rejectionNo = event.data.rejectionNo || "";
        data.rate = event.data.rate || 0;
        data.weight = "";
        this.setState({ itemObject: data, isSelectItemPopUp: false });
    };

    usp_Master_ItemSelectbyID_JobWork = (id) => {
        let request = {
            idItem: id,
            idVendor: this.state.materialObject.idVendor,
        }
        if (id !== 0 && this.state.materialObject.idVendor !== 0) {
            this.transactionStockServices.usp_Master_ItemSelectbyID_JobWork(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent[0];
                    let details = this.state.itemObject;
                    details.idTaxGroup = data.idTaxGroup ? data.idTaxGroup : 0;
                    details.rate = data.finalItemRate ? data.finalItemRate : 0;
                    details.drawingNo = data.drawingNo ? data.drawingNo : "";
                    this.setState({ itemObject: details }, () => {
                        this.getTaxStructureSelectbyID();
                    })
                }
            });
        }
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [
            this.state.idCompany,
            label,
            this.state.materialObject.idVendor
        ];
        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    itemList: data,
                });
            }
        });
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.itemObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.itemObject.idTaxGroup).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.itemObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ itemObject: data }, () => {
                        this.calculatePricing();
                    });
                }
            });
        }
    }

    calculatePricing = () => {
        if (this.state.itemObject.rate) {
            let itemObject = this.state.itemObject;
            let materialObject = this.state.materialObject;
            itemObject.total = 0;
            itemObject.sgstAmt = 0;
            itemObject.cgstAmt = 0;
            itemObject.igstAmt = 0;
            itemObject.netTotal = 0;
            itemObject.amount = 0
            itemObject.amount = (Number(itemObject.quantity) * Number(itemObject.rate)).toFixed(2);
            itemObject.total = Number(itemObject.amount);
            itemObject.sgstAmt = materialObject.idRejType === 1 ? Number(((itemObject.total * itemObject.sgst) / 100).toFixed(2)) : 0;
            itemObject.cgstAmt = materialObject.idRejType === 1 ? Number(((itemObject.total * itemObject.cgst) / 100).toFixed(2)) : 0;
            itemObject.igstAmt = Number(itemObject.igst) > 0 ? materialObject.idRejType === 1 ? 0 : Number(((itemObject.total * itemObject.igst) / 100).toFixed(2)) : 0;
            itemObject.netTotal = (
                Number(itemObject.total) +
                Number(itemObject.sgstAmt) +
                Number(itemObject.cgstAmt) +
                Number(itemObject.igstAmt)
            ).toFixed(2);
            this.setState({ itemObject: itemObject });
        }
    }

    insert = (flag) => {
        let isValid = this.isValidAllFieldsForItem();
        if (!isValid) {
            this.SwalServices.Error("Please fill all required fields.");
            return;
        }
        if (flag === 'Insert') {
            let details = this.state.itemObject;
            let array = this.state.itemRowData;

            const isItemExists = array.some(x => x.idMaterialRejectionItems === details.idMaterialRejectionItems);

            if (isItemExists) {
                this.SwalServices.Error("This item is already added.");
                return;
            }
            if (Number(details.quantity) > Number(details.pendingQty)) {
                this.SwalServices.Error("Quantity cannot be greater than pending quantity.");
                return;
            }
            let itemList = [...this.state.itemRowData];
            let obj = {
                drawingNo: details.drawingNo,
                idType: details.idType,
                materialType: details.materialType ? details.materialType : details.TypeList.find(x => x.value === details.idType)?.label,
                idItem: details.idItem,
                itemName: details.itemIdLabel,
                quantity: Number(details.quantity),
                weight: details.weight ? Number(details.weight) : 0,
                rate: details.rate ? Number(details.rate) : 0,
                remarks: details.remarks,
                idMaterialRejection: details.idMaterialRejection,
                idMaterialRejectionItems: details.idMaterialRejectionItems,
                pendingQty: details.pendingQty,
                rejectionNo: details.rejectionNo,
            }
            itemList.push(obj);
            itemList.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList }, () => {
                this.resetitemObject();
            });
        }
        else if (flag === 'Update') {
            let details2 = this.state.itemObject;
            if (Number(details2.quantity) > Number(details2.pendingQty)) {
                this.SwalServices.Error("Quantity cannot be greater than pending quantity.");
                return;
            }
            let itemList2 = [...this.state.itemRowData];
            // Spread the existing row so the source linkage ids (idMaterialRejection,
            // idMaterialRejectionItems, idMaterialRejectionOutwardItems) are preserved.
            itemList2[details2.keyId - 1] = {
                ...itemList2[details2.keyId - 1],
                drawingNo: details2.drawingNo,
                idType: details2.idType,
                materialType: details2.TypeList.find(x => x.value === details2.idType)?.label,
                idItem: details2.idItem,
                itemName: details2.itemIdLabel,
                quantity: Number(details2.quantity),
                weight: details2.weight ? Number(details2.weight) : 0,
                rate: details2.rate ? Number(details2.rate) : 0,
                remarks: details2.remarks,
            };
            itemList2.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList2 }, () => {
                this.resetitemObject();
            });
        }
    }

    resetitemObject = () => {
        let details = this.state.itemObject;
        details.drawingNo = '';
        details.idType = 1;
        details.idItem = 0;
        details.itemIdLabel = "";
        details.quantity = 0;
        details.weight = "";
        details.rate = 0;
        details.amount = 0;
        details.idTaxGroup = "";
        details.sgst = "";
        details.sgstAmt = "";
        details.cgst = "";
        details.cgstAmt = "";
        details.igst = "";
        details.igstAmt = "";
        details.netTotal = "";
        details.remarks = "";
        details.keyId = "";
        details.idMaterialRejection = 0;
        details.idMaterialRejectionItems = 0;
        details.materialType = "";
        details.pendingQty = 0;
        details.rejectionNo = "";
        this.setState({ itemObject: details })
    }

    finalCalculation = () => {
        let data = this.state.itemRowData;
        let finalAmountCal = this.state.materialObject;

        finalAmountCal.totalQty = 0;
        finalAmountCal.totalAmt = 0;
        finalAmountCal.taxAmt = 0;
        finalAmountCal.totalwithTax = 0;
        finalAmountCal.taxableAmt = 0;
        finalAmountCal.finalAmt = 0;

        data.map((x) => {
            finalAmountCal.totalQty += Number(x.quantity);
            finalAmountCal.totalAmt += Number(x.amount);
            finalAmountCal.taxAmt += Number(x.sgstAmt) + Number(x.cgstAmt) + Number(x.igstAmt);
            finalAmountCal.taxableAmt += Number(x.total)
            finalAmountCal.finalAmt += Number(x.netTotal);
        });

        finalAmountCal.totalwithTax =
            Number(finalAmountCal.totalAmt) + Number(finalAmountCal.taxAmt);

        finalAmountCal.finalAmt = Number(finalAmountCal.totalwithTax).toFixed(2);

        finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt).toFixed(2)
        finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt).toFixed(2);
        finalAmountCal.taxAmt = Number(finalAmountCal.taxAmt).toFixed(2);
        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsAmt).toFixed(2);
        finalAmountCal.totalwithTax = Number(finalAmountCal.totalwithTax).toFixed(2);
        finalAmountCal.finalAmt = Math.round(Number(finalAmountCal.finalAmt) + (Number(finalAmountCal.adjustableAmt) || 0));

        this.setState({ materialObject: finalAmountCal });
    }

    onItemRowDataClicked = (event) => {
        let data = [...this.state.itemRowData];
        let getItemData = data[event.data.keyId - 1];
        let details = this.state.itemObject;

        details.drawingNo = getItemData.drawingNo;
        details.idType = getItemData.idType;
        details.materialType = getItemData.materialType;
        details.itemIdLabel = getItemData.itemName;
        details.idItem = getItemData.idItem;
        details.quantity = getItemData.quantity;
        details.weight = getItemData.weight;
        details.rate = getItemData.rate;
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        details.idMaterialRejection = getItemData.idMaterialRejection;
        details.idMaterialRejectionItems = getItemData.idMaterialRejectionItems;
        details.pendingQty = getItemData.pendingQty;
        details.rejectionNo = getItemData.rejectionNo;
        this.setState({ itemObject: details });
    };

    submit = () => {
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFieldsForRegister = this.isValidAllFieldsForRegister();
        if (isValidAllFieldsForRegister) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add product items details");
            } else {
                let data = this.state.materialObject
                let itemObject = this.state.itemObject;
                let request = {
                    idMaterialRejectionOutward: data.idMaterialRejection,
                    updateStatus: data.updateStatus,
                    rejectionOutwardNo: data.rejectionNo,
                    rejectionOutwardDate: data.rejectionDate && data.rejectionDate !== 'Invalid date' ? data.rejectionDate : null,
                    idEmployee: data.idEmployee,
                    idMaterial: data.idMaterial,
                    isApprove: data.isApprove ? true : false,
                    remarks: data.remarks ? data.remarks : "",
                    idCompany: this.state.idCompany,
                    prefix: data.prefix,
                    e_Date: data.e_Date ? moment(data.e_Date).format('YYYY-MM-DD') : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? moment(new Date().toISOString()).format('YYYY-MM-DD') : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: 0,
                };
                request.itemList = [];
                let itemList = this.state.itemRowData;
                itemList.map((details) => {
                    let obj = {
                        idMaterialRejection: details.idMaterialRejection,
                        idMaterialRejectionItems: details.idMaterialRejectionItems,
                        drawingNo: details.drawingNo,
                        itemType: details.materialType ? details.materialType : itemObject.TypeList.find(x => x.value === details.idType)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        weight: details.weight ? details.weight : 0,
                        rate: details.rate ? details.rate : 0,
                        itemRemarks: details.remarks,
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitMaterialRejectionOutward(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.materialObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            this.setState({
                                isModalOpen: false,
                            }, () => {
                                this.resetDetailsFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    deleteItem = (keyId) => {
        let data = this.state.itemObject;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }

        this.setState({ itemObject: { ...data }, itemRowData: filterData }, () => {
            this.resetitemObject();
            this.finalCalculation();
        });
    }

    getMaterialRejectionOutwardSelectbyId = (idMaterialRejectionOutward) => {
        if (idMaterialRejectionOutward > 0) {
            this.transactionStockServices.usp_Transaction_MaterialRejectionOutwardSelectbyId(idMaterialRejectionOutward).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let materialObject = this.state.materialObject;
                    materialObject.idMaterialRejection = res.idMaterialRejectionOutward;
                    materialObject.updateStatus = 1;
                    materialObject.rejectionNo = res.rejectionOutwardNo;
                    materialObject.rejectionDate = res.rejectionOutwardDate ? moment(res.rejectionOutwardDate).format('YYYY-MM-DD') : null;
                    materialObject.idMaterial = res.idMaterial ? res.idMaterial : 0;
                    materialObject.materialName = res.material ? res.material : '';
                    materialObject.isApprove = res.isApprove ? true : false;
                    materialObject.idEmployee = res.idEmployee ? res.idEmployee : 0;
                    materialObject.e_Date = res.e_Date;
                    materialObject.prefix = res.prefix ? res.prefix : '';
                    materialObject.remarks = res.remarks ? res.remarks : '';

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            keyId: keyId + 1,
                            idMaterialRejectionOutwardItems: details.idMaterialRejectionOutwardItems,
                            idMaterialRejection: details.idMaterialRejection,
                            idMaterialRejectionItems: details.idMaterialRejectionItems,
                            drawingNo: details.drawingNo,
                            idType: this.state.itemObject.TypeList?.find(x => x.label === details.itemType)?.value || "",
                            materialType: details.itemType ? details.itemType : "",
                            idItem: details.idItem ? details.idItem : 0,
                            itemName: details.itemName ? details.itemName : "",
                            quantity: details.quantity ? details.quantity : 0,
                            weight: details.weight ? details.weight : 0,
                            rate: details.rate ? details.rate : 0,
                            remarks: details.itemRemarks,
                            pendingQty: details.pendingQty ? details.pendingQty : 0,
                            rejectionNo: details.rejectionNo ? details.rejectionNo : "",
                        }
                        itemList.push(obj);
                    })
                    this.setState({ materialObject: materialObject, itemRowData: itemList, isModalOpen: true });
                }
            });
        }
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialRejectionOutwardPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            materialObject={this.state.materialObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleApproveChange={this.handleApproveChange.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            partyAccountList={this.state.partyAccountList}
                            handleOnClick={this.handleOnClick.bind(this)}
                            insert={this.insert.bind(this)}
                            handleCellClickItemList={this.handleDropdownCellClick.bind(this)}
                            onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                            clearItemObject={this.resetitemObject.bind(this)}
                            delete={this.deleteItem.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                            materialList={this.state.materialList}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 350px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material rejection outward</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.rejectedItemList}
                    colDefs={this.state.selectRejItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
            </div>
        )
    }
}
